import { PopoverProps } from "@mui/material";
import { useCallback, useState } from "react";

export interface UseMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
  anchorToClick?: boolean;
  anchorOrigin?: PopoverProps["anchorOrigin"];
  anchorPosition?: PopoverProps["anchorPosition"];
}

export interface UseMenuFields extends UseMenuProps {
  setAnchorEl: (el: HTMLElement | null) => void;
  handleOpen: (event: React.MouseEvent<HTMLElement>) => void;
}

export const useMenu: () => UseMenuFields = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  }, []);

  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return { anchorEl, open, handleOpen, onClose, setAnchorEl };
};
